import { useState, useEffect } from 'react';
import { customerTicketService } from '../services/customerTicketService';
import { CustomerTicket } from '../types/customerTicket';

export const useCustomerTickets = (organizationId?: string) => {
  const [tickets, setTickets] = useState<CustomerTicket[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!organizationId) {
      setTickets([]);
      setLoading(false);
      return;
    }

    loadTickets();
  }, [organizationId]);

  const loadTickets = async () => {
    if (!organizationId) return;

    try {
      setLoading(true);
      setError(null);
      const data = await customerTicketService.getProjectsByOrganization(organizationId);
      setTickets(data);
    } catch (err) {
      console.error('Error loading support tickets:', err);
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  };

  const refresh = () => {
    loadTickets();
  };

  return {
    tickets,
    loading,
    error,
    refresh
  };
};

export const useCustomerTicketsByCustomer = (customerId?: string) => {
  const [tickets, setTickets] = useState<CustomerTicket[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!customerId) {
      setTickets([]);
      setLoading(false);
      return;
    }

    loadTickets();
  }, [customerId]);

  const loadTickets = async () => {
    if (!customerId) return;

    try {
      setLoading(true);
      setError(null);
      const data = await customerTicketService.getProjectsByCustomer(customerId);
      setTickets(data);
    } catch (err) {
      console.error('Error loading customer tickets:', err);
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  };

  const refresh = () => {
    loadTickets();
  };

  return {
    tickets,
    loading,
    error,
    refresh
  };
};
